import script from "./msg.vue?vue&type=script&setup=true&name=Msg&lang=js"
export * from "./msg.vue?vue&type=script&setup=true&name=Msg&lang=js"

import "./msg.vue?vue&type=style&index=0&id=7ffea3ba&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\hujing\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ffea3ba"]])

export default __exports__